import React, { useEffect, useState } from 'react'

import { FormikProps } from 'formik'
import produce from 'immer'

import {
  DeliveryForecastDespatchAdviceItemBatch,
  DeliveryForecastDespatchAdvicePackagingBatch,
} from '../../../../../../../data/models'
import {
  FormFieldConfig,
  PackagingItem,
  ReadonlyFieldConfig,
} from '../../../../../../ui-config/data'
import { useAllDeliveryForecastDespatchAdviceItemBatches } from '../../../../../data/hooks'
import { FormFieldName } from '../FormFieldName'
import { FormValues } from '../FormValues'
import { BatchesTableView } from './BatchesTable.view'

type Props = {
  config: PackagingItem<ReadonlyFieldConfig | FormFieldConfig>
  despatchAdviceId: string
  itemId: string
  formik: FormikProps<FormValues>
  isFormFieldValid: (name: FormFieldName, index?: number) => boolean
  getFormErrorMessage: (
    name: FormFieldName,
    index?: number,
  ) => false | JSX.Element
  children?: JSX.Element
}

export const BatchesTableData: React.FC<Props> = ({
  config,
  despatchAdviceId,
  itemId,
  formik,
  isFormFieldValid,
  getFormErrorMessage,
  children,
}) => {
  const {
    data: batches,
    isLoading,
    error,
  } = useAllDeliveryForecastDespatchAdviceItemBatches(
    despatchAdviceId,
    itemId,
    true,
  )

  const [batchOptions, setBatchOptions] = useState<
    DeliveryForecastDespatchAdvicePackagingBatch[]
  >([])

  useEffect(() => {
    setBatchOptions(getBatchOptions(batches, formik.values.batches))
  }, [batches])

  const getBatchOptions = (
    batches?: DeliveryForecastDespatchAdviceItemBatch[],
    formBatches?: DeliveryForecastDespatchAdvicePackagingBatch[],
  ) => {
    const batchOptions: DeliveryForecastDespatchAdviceItemBatch[] = []

    if (batches?.length === 0) return []

    batches?.forEach(batch => {
      const batchHasOpenQuantity = batch.OpenQuantity !== 0
      const batchIsInFormik = formBatches?.some(
        formikBatch => formikBatch.Batchnumber === batch.Batchnumber,
      )

      if (batchHasOpenQuantity || batchIsInFormik) {
        const newBatch = produce(batch, draft => {
          // @ts-ignore
          draft.BatchId = draft.Id
          draft.Quantity = draft.OpenQuantity || draft.Quantity
          draft.OpenQuantity = draft.OpenQuantity || draft.Quantity
        })
        batchOptions.push(newBatch)
      }
    })

    return batchOptions
  }

  const addBatchOptions = (
    newBatches: DeliveryForecastDespatchAdvicePackagingBatch[],
  ) => {
    const newBatchOptions = [
      ...batchOptions,
      ...newBatches.filter(
        newBatch =>
          // Only add new batches that are not already in batchOptions
          !batchOptions?.some(option => option.BatchId === newBatch.BatchId),
      ),
    ]

    setBatchOptions(newBatchOptions)
  }

  return (
    <BatchesTableView
      config={config}
      formik={formik}
      batchOptions={batchOptions}
      addBatchOptions={addBatchOptions}
      isFormFieldValid={isFormFieldValid}
      getFormErrorMessage={getFormErrorMessage}
      children={children}
    />
  )
}
